import * as React from "react";

const SvgIcnArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M9.203 8.113a.626.626 0 010-.922.723.723 0 01.979 0l4.615 4.35c.27.255.27.668 0 .923l-4.61 4.345a.723.723 0 01-.978 0 .626.626 0 010-.922l4.12-3.884-4.126-3.89z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default SvgIcnArrowRight;
